'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEX_CODE_REGEX = new RegExp('^#([A-Fa-f0-9]{2})([A-Fa-f0-9]{2})([A-Fa-f0-9]{2})|^#([A-Fa-f0-9]{1})([A-Fa-f0-9]{1})([A-Fa-f0-9]{1})$');

exports.default = HEX_CODE_REGEX;
module.exports = exports['default'];